import { Component, inject } from '@angular/core';
// Service
import { AuthzService } from '../../core/auth/authz.service';
import { LoggingService } from '../../core/utils/logging.service';
// PrimeNG
import { ButtonModule } from 'primeng/button';
import { ImageModule } from 'primeng/image';
import { TranslocoModule } from '@jsverse/transloco';
import { LanguageConfigComponent } from '../../pattern/language-config/language-config.component';

@Component({
  selector: 'app-success-verify-email',
  imports: [ImageModule, ButtonModule, TranslocoModule, LanguageConfigComponent],
  template: `
    <div class="flex h-screen flex-column">
      <div class="flex justify-content-end w-full p-3">
        <app-language-config></app-language-config>
      </div>
      <div class="flex h-full w-full justify-content-center align-items-center bg-landing">
        <div
          class="flex flex-column gap-4 justify-content-center align-items-center border-round-2xl bg-white"
          style="width: 420px; height:310px"
        >
          <p-image src="assets/images/img-verify-email.png" alt="verify-email" width="62px" />
          <p class="text-lg text-color font-semibold text-center">{{ 'success-verify-email.header' | transloco }}</p>
          <p class="text-center text-xs text-bluegray-500 font-normal text-center px-4">
            {{ 'success-verify-email.sub-header1' | transloco }}
            <br />
            {{ 'success-verify-email.sub-header2' | transloco }}
          </p>
          <div class="w-full px-6">
            <p-button
              [label]="'success-verify-email.button' | transloco"
              styleClass="w-full"
              (click)="handleLoginAuth0()"
            />
          </div>
        </div>
      </div>
    </div>
  `,
  styles: ``,
})
export class SuccessVerifyEmailComponent {
  private authz = inject(AuthzService);
  private readonly loggingService = inject(LoggingService);

  handleLoginAuth0() {
    this.loggingService.error('handleLoginAuth0');
    // this.auth0.loginWithRedirect()
    this.authz.login();
  }
}
